"use strict";
// tslint:disable
/**
 * Laravel WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferDetailsGradeEnum = exports.OfferDetailsToJSON = exports.OfferDetailsFromJSONTyped = exports.OfferDetailsFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function OfferDetailsFromJSON(json) {
    return OfferDetailsFromJSONTyped(json, false);
}
exports.OfferDetailsFromJSON = OfferDetailsFromJSON;
function OfferDetailsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'title': json['title'],
        'grade': json['grade'],
        'description': json['description'],
        'addressId': !runtime_1.exists(json, 'address_id') ? undefined : json['address_id'],
        'upvote': !runtime_1.exists(json, 'upvote') ? undefined : json['upvote'],
        'category': _1.CategoryFromJSON(json['category']),
        'dimensions': !runtime_1.exists(json, 'dimensions') ? undefined : _1.OfferDimensionsFromJSON(json['dimensions']),
        'enclosure': _1.EnclosureFromJSON(json['enclosure']),
    };
}
exports.OfferDetailsFromJSONTyped = OfferDetailsFromJSONTyped;
function OfferDetailsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'title': value.title,
        'grade': value.grade,
        'description': value.description,
        'address_id': value.addressId,
        'upvote': value.upvote,
        'category': _1.CategoryToJSON(value.category),
        'dimensions': _1.OfferDimensionsToJSON(value.dimensions),
        'enclosure': _1.EnclosureToJSON(value.enclosure),
    };
}
exports.OfferDetailsToJSON = OfferDetailsToJSON;
/**
* @export
* @enum {string}
*/
var OfferDetailsGradeEnum;
(function (OfferDetailsGradeEnum) {
    OfferDetailsGradeEnum["A"] = "A";
    OfferDetailsGradeEnum["B"] = "B";
    OfferDetailsGradeEnum["C"] = "C";
    OfferDetailsGradeEnum["D"] = "D";
})(OfferDetailsGradeEnum = exports.OfferDetailsGradeEnum || (exports.OfferDetailsGradeEnum = {}));
